module.exports = __webpack_public_path__ + "img/sso.0352bf74.jpg";